import t from 'react-translate';
import { useSelector } from 'react-redux';

import { NovoAIItemType } from 'redux/schemas/models/lecture-page';
import { getCourseAliases } from 'redux/selectors/course';

import {
  ReactComponent as SummaryIcon,
} from 'styles/icons/ai-summary.svg';
import {
  ReactComponent as KeyTakeawaysIcon,
} from 'styles/icons/ai-key-takeaways.svg';
import {
  ReactComponent as DiscussionIcon,
} from 'styles/icons/ai-discussion.svg';
import {
  ReactComponent as FeedbackIcon,
} from 'styles/icons/ai-public-feedback.svg';
import {
  ReactComponent as QuizIcon,
} from 'styles/icons/ai-quiz.svg';
import {
  ReactComponent as PollIcon,
} from 'styles/icons/ai-poll.svg';
import {
  ReactComponent as SummaryLgIcon,
} from 'styles/icons/ai-lg-summary.svg';
import {
  ReactComponent as QuizLgIcon,
} from 'styles/icons/ai-lg-quiz.svg';
import {
  ReactComponent as DiscussionLgIcon,
} from 'styles/icons/ai-lg-discussion.svg';
import {
  ReactComponent as AssignmentIcon,
} from 'styles/icons/ai-assignment.svg';
import {
  ReactComponent as PollLgIcon,
} from 'styles/icons/ai-lg-poll.svg';
import {
  ReactComponent as AssignmentLgIcon,
} from 'styles/icons/ai-lg-assignment.svg';
import {
  ReactComponent as SurveyLgIcon,
} from 'styles/icons/ai-lg-survey.svg';
import {
  ReactComponent as SurveyIcon,
} from 'styles/icons/ai-survey.svg';
import {
  ReactComponent as FeedbackLgIcon,
} from 'styles/icons/ai-lg-feedback.svg';

const useAiItemMetadata = () => {
  const aliases = useSelector((state) => getCourseAliases(state));

  const itemTypeIcons = {
    [NovoAIItemType.SUMMARY]: SummaryIcon,
    [NovoAIItemType.KEY_TAKEAWAYS]: KeyTakeawaysIcon,
    [NovoAIItemType.DISCUSSION]: DiscussionIcon,
    [NovoAIItemType.POLL]: PollIcon,
    [NovoAIItemType.ASSIGNMENT]: AssignmentIcon,
    [NovoAIItemType.PUBLIC_FEEDBACK]: FeedbackIcon,
    [NovoAIItemType.PRE_SURVEY]: SurveyIcon,
    [NovoAIItemType.POST_SURVEY]: SurveyIcon,
    [NovoAIItemType.QUIZ]: QuizIcon,
  };

  const modalItemTypeIcons = {
    [NovoAIItemType.QUIZ]: QuizLgIcon,
    [NovoAIItemType.DISCUSSION]: DiscussionLgIcon,
    [NovoAIItemType.SUMMARY]: SummaryLgIcon,
    [NovoAIItemType.KEY_TAKEAWAYS]: SummaryLgIcon,
    [NovoAIItemType.POLL]: PollLgIcon,
    [NovoAIItemType.ASSIGNMENT]: AssignmentLgIcon,
    [NovoAIItemType.PRE_SURVEY]: SurveyLgIcon,
    [NovoAIItemType.POST_SURVEY]: SurveyLgIcon,
    [NovoAIItemType.PUBLIC_FEEDBACK]: FeedbackLgIcon,
  };

  const itemTextMapping = {
    [NovoAIItemType.SUMMARY]: t.LECTURE_PAGES.LHS.NOVO_AI.ITEM.TITLE.SUMMARY(),
    [NovoAIItemType.KEY_TAKEAWAYS]: t.LECTURE_PAGES.LHS.NOVO_AI.ITEM.TITLE.KEY_TAKEAWAYS(),
    [NovoAIItemType.DISCUSSION]: t.LECTURE_PAGES.COMPONENTS.DISCUSSION.DESCRIPTION(),
    [NovoAIItemType.POLL]: t.LECTURE_PAGES.LHS.NOVO_AI.ITEM.TITLE.POLL(),
    [NovoAIItemType.ASSIGNMENT]: t.LECTURE_PAGES.COMPONENTS.EXERCISE.DESCRIPTION(aliases.assignmentAliases),
    [NovoAIItemType.PUBLIC_FEEDBACK]: t.LECTURE_PAGES.COMPONENTS.PEER_EVALUATION.ASSIGNMENT.PUBLIC(),
    [NovoAIItemType.PRE_SURVEY]: t.LECTURE_PAGES.LHS.NOVO_AI.ITEM.TITLE.PRE_SURVEY(),
    [NovoAIItemType.POST_SURVEY]: t.LECTURE_PAGES.LHS.NOVO_AI.ITEM.TITLE.POST_SURVEY(),
    [NovoAIItemType.QUIZ]: t.LECTURE_PAGES.COMPONENTS.QUIZ.DESCRIPTION(),
  };

  return {
    itemTextMapping,
    itemTypeIcons,
    modalItemTypeIcons,
  };
};

export default useAiItemMetadata;
